// FestPro tab set (fp-split's Owner Manuals tabs, fp-product-content's Features). Click or arrow keys switch tabs;
// selecting a tab block in the theme editor shows that tab.
if (!customElements.get('fp-tabs')) {
  class FpTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.onBlockSelect = (event) => {
        const index = this.panels.indexOf(event.target);
        if (index > -1) this.select(index);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      if (this.wired) return; // element listeners survive a disconnect; only the document one is re-added
      this.wired = true;
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
      });
      this.addEventListener('keydown', (event) => {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;
        const last = this.tabs.length - 1;
        const next = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: last }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select((next + this.tabs.length) % this.tabs.length, true);
      });
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
      if (focus) this.tabs[index].focus();
    }
  }

  customElements.define('fp-tabs', FpTabs);
}
